// 工事編集 工事情報画面
import {
  Button,
  Divider,
  Grid,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  useMediaQuery,
  Tooltip,
  LinearProgress
} from '@material-ui/core';
import { createStyles, makeStyles, withStyles } from '@material-ui/core/styles';
import AddToPhotosIcon from '@material-ui/icons/AddToPhotos';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import DeleteIcon from '@material-ui/icons/Delete';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import _ from 'lodash';
import React, { useCallback, useEffect, useState, useContext } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import {
  // getAssigneeRoles, getConstructInvoices, getConstructionDetails, getConstructionTypes, getConstructMerchandise,
  // getConstructOutSources, getConstructSiteContacts, getPrefectureList, getScaleList, updateConstruction
  getAssigneeRoles,
  getConstructionDetails,
  getConstructionTypes,
  getPrefectureList,
  getScaleList,
  updateConstruction,
  getConstructSiteContacts
} from '../apicalls/construction';
import { getEmployeeMasterList } from '../apicalls/employeeMaster';
import '../App.css';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import LoadingComponent from '../components/LoadingComponent';
import NumberInput from '../components/NumberInput';
import {
  btnColor,
  invalidPhoneNumberRegex,
  isLoggedIn,
  mainBlueColor,
  userRole,
  userMenuId,
  tenantTaxRuleState,
  userSiteManagePlanId
} from '../GlobalState';
import { parsePrice } from '../utils';
import { calcTax } from '../utils/common';
import './List.css';
import {
  EXT_INFO_SCREEN_TYPE,
  SITE_MANGE_PLAN_ACCESS_ALLOW
} from '../const/Const';
import HelpIcon from '@material-ui/icons/Help';
import { ListButton } from '../components/parts/cloudStorage/style/style';
import { useParams } from 'react-router-dom';
import { ExtInfoBoxes } from '../components/extInfoBox/ExtInfoBoxes';
import { fetchAddressFromPostalCode } from '../apicalls/createCustomer';
import { TInfoBox } from '../types/ExtInfoBox';
import { getExtInfoBoxes } from '../apicalls/extInfoBox';
import { CustomTooltip } from '../components/tooltip/CustomTooltip';
import { tooltipContents } from '../components/tooltip/Const';
import { TTopicPathState } from '../components/topicPath/type/Type';
import { AuthInfoContext } from '../AuthContextProvider';
import { ROLE, ASSIGNEE_ROLE } from '../const/Const';
import { getUserSelectOptions } from '../utils/processAndTaskFormUtils';
import { getStaffSelectOptions } from '../utils/getStaffSelectOptions';
import { StaffData } from '../types/staffData';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    },
    '&:hover': {
      backgroundColor: '#CFCFCF'
    }
  }
}))(TableRow);

export const EditConstruction: React.FC = () => {
  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);
  const [isPhoneNumber] = useRecoilState(invalidPhoneNumberRegex);
  const [userPermission] = useRecoilState(userRole);
  const [userMenu] = useRecoilState(userMenuId);
  const [taxRule] = useRecoilState(tenantTaxRuleState);
  const [authInfo, setAuthInfo] = useContext(AuthInfoContext);

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      subContainer: {
        marginLeft: 15,
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row'
      },
      topBoxText: {
        fontSize: 14,
        color: '#FFFFFF'
      },
      container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 15
      },
      table1: {},
      inputMainContainer: {
        display: 'flex',
        backgroundColor: '#F5F5F5',
        minHeight: 60,
        alignItems: 'center',
        width: '100%'
      },
      inputnew: {
        minHeight: 100,
        maxHeight: 120,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1
      },
      inputContainer: {
        marginLeft: 10,
        marginRight: 10,
        paddingRight: 10,
        width: '100%'
      },
      textMainContainer2: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        minHeight: 125,
        alignItems: 'center'
      },
      textMainContainer: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        minHeight: 60,
        alignItems: 'center'
      },
      textContainer: {
        marginLeft: 15,
        color: '#FFFFFF',
        fontSize: 14
      },
      input: {
        minHeight: 40,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1
      },
      inputMainContainer1: {
        display: 'flex',
        backgroundColor: '#F5F5F5',
        minHeight: 80,
        alignItems: 'center',
        width: '100%'
      },
      textMainContainer1: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        minHeight: 80,
        alignItems: 'center'
      },
      textContainer1: {
        marginLeft: 15,
        color: '#FFFFFF',
        fontSize: 14
      },
      input1: {
        minHeight: 60,
        width: '100%'
      },
      inputContainerSelectBox: {
        marginLeft: 10,
        marginRight: 13,
        width: '100%'
      },
      inputContainerSelectBoxAlignRight: {
        marginLeft: 10,
        marginRight: 13,
        width: '100%',
        textAlign: 'right'
      },
      textContainerPrice: {
        marginLeft: 10,
        marginRight: 13,
        textAlign: 'right',
        width: '100%'
      },
      main: {
        minWidth: 700
      },
      table: {
        backgroundColor: `${mainColor} !important`,
        color: '#FFFFFF',
        fontWeight: 'bold',
        fontSize: 16
      },
      selectBoxStyle: {
        WebkitAppearance: 'menulist-button',
        backgroundColor: 'white',
        borderColor: '#c1c1c1',
        minHeight: 48,
        width: '100%'
      },
      inputBottom: {
        height: 30,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1
      },
      inputContributionListBottom: {
        height: 30,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1,
        textAlign: 'right'
      },
      inputPostalCode: {
        height: 40,
        borderColor: '#c1c1c1',
        borderWidth: 1
      },
      tooltip: {
        fontSize: 14
      },
      topContainer: {
        display: 'flex',
        paddingBottom: 15,
        justifyContent: 'space-between'
      },
      topList: {
        display: 'flex',
        marginTop: 25,
        marginBottom: 25,
        width: '100%',
        justifyContent: 'flex-start'
      },
      topColumn: {
        fontSize: 16,
        color: '#000000'
      },
      progress: {
        backgroundColor: '#c1c1c1',
        '& .MuiLinearProgress-barColorPrimary': {
          backgroundColor: mainColor
        }
      }
    })
  );

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const classes = useStyles();
  const history: any = useHistory();
  const matches2 = useMediaQuery('(min-width:900px)');
  const [userSiteManagePlan, setUserSiteMangePlan] =
    useRecoilState<any>(userSiteManagePlanId);
  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );

  const [open, setOpen] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [typesData, setTypesData] = useState([]);
  const [scaleData, setScaleData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [prefectureData, setPrefectureData] = useState([]);
  const [assigneeRoleData, setAssigneeRoleData] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');

  const [code, setCode] = useState('');
  const [constructType, setConstructType] = useState<number>(0);
  const [renewStatus, setRenewStatus] = useState<number>(0);
  const [buildingScale, setBuildingScale] = useState<number>(0);
  const [name, setName] = useState('');
  const [sitePrefecture, setSitePrefecture] = useState<number>(0);
  const [siteAddress1, setSiteAddress1] = useState('');
  const [siteAddress2, setSiteAddress2] = useState('');
  const [siteAddress3, setSiteAddress3] = useState('');
  const [remarks, setRemarks] = useState<string>('');
  const [contractorPrefecture, setContractorPrefecture] = useState<number>(0);
  const [contractorAddress1, setContractorAddress1] = useState('');
  const [contractorAddress2, setContractorAddress2] = useState('');
  const [contractorAddress3, setContractorAddress3] = useState('');
  const [contractorName, setContractorName] = useState('');
  const [contractorTel, setContractorTel] = useState('');
  const [progress, setProgress] = useState<number>(0);
  const [plannedCost, setPlannedCost] = useState<number>(0);
  const [plannedDays, setPlannedDays] = useState<number>(0);
  const [plannedGrossProfit, setPlannedGrossProfit] = useState<number>(0);
  const [plannedGrossProfitRate, setPlannedGrossProfitRate] =
    useState<number>(0);
  const [smallExpenses, setSmallExpenses] = useState<number>(0);

  const [contractDate, setContractDate] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [billingDate, setBillingDate] = useState('');
  const [paymentDate, setPaymentDate] = useState('');
  const [failureDate, setFailureDate] = useState('');
  const [inspectionDate, setInspectionDate] = useState('');

  const [clientName, setClientName] = useState('');
  const [clientTel, setClientTel] = useState('');
  const [clientPrefecture, setClientPrefecture] = useState('');
  const [clientAddress1, setClientAddress1] = useState('');
  const [clientAddress2, setClientAddress2] = useState('');
  const [clientAddress3, setClientAddress3] = useState('');

  const [contractTaxRate, setContractTaxRate] = useState<number>(10);

  const [expectedContractDate, setExpectedContractDate] = useState('');
  const [expectedStartDate, setExpectedStartDate] = useState('');
  const [expectedEndDate, setExpectedEndDate] = useState('');
  const [expectedPaymentDate, setExpectedPaymentDate] = useState('');

  const [loading, setLoading] = useState(true);

  const [itemIds, setItemIds] = useState<any>([]);
  const [itemIds2, setItemIds2] = useState<any>([]);

  const [rowCount, setRowCount] = useState<any>([1]);
  const [rowCount2, setRowCount2] = useState<any>([]);
  const [assigneeUser, setAssigneeUser] = useState<any>([]);
  const [assigneeRole, setAssigneeRole] = useState<any>([]);
  const [contributionList, setContributionList] = useState<any>([]);
  const [individualSalesList, setIndividualSalesList] = useState<any>([]);
  const [assigneeOutsidePartner, setAssigneeOutsidePartner] = useState<any>([
    0
  ]);
  const [assigneeOutsidePartnerRole, setAssigneeOutsidePartnerRole] =
    useState<any>([0]);

  // 工事詳細を開いた時のみ変更
  const [topConstructionName, setTopConstructionName] = useState('');
  const [topClientName, setTopClientName] = useState('');

  // 変更内容を保存していない場合False
  const [isSaved, setIsSaved] = useState<boolean>(true);

  const [staffDataList, setStaffDataList] = useState<StaffData[]>([]);

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleCloseSuccess = (
    event?: React.SyntheticEvent,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSuccess(false);
  };

  const [selectedContractDate, setSelectedContractDate] =
    useState<Date | null>(null);
  const [selectedStartDate, setSelectedStartDate] = useState<Date | null>(null);
  const [selectedEndDate, setSelectedEndDate] = useState<Date | null>(null);
  const [selectedBillingDate, setSelectedBillingDate] =
    useState<Date | null>(null);
  const [selectedPaymentDate, setSelectedPaymentDate] =
    useState<Date | null>(null);
  const [selectedFailureDate, setSelectedFailureDate] =
    useState<Date | null>(null);
  const [selectedInspectionDate, setSelectedInspectionDate] =
    useState<Date | null>(null);
  const [selectedExpectedContractDate, setSelectedExpectedContractDate] =
    useState<Date | null>(null);
  const [selectedExpectedStartDate, setSelectedExpectedStartDate] =
    useState<Date | null>(null);
  const [selectedExpectedEndDate, setSelectedExpectedEndDate] =
    useState<Date | null>(null);
  const [selectedExpectedPaymentDate, setSelectedExpectedPaymentDate] =
    useState<Date | null>(null);

  const [orderAmount, setOrderAmount] = useState<number>(0);
  const [orderAmountTaxIncluded, setOrderAmountTaxIncluded] =
    useState<number>(0);
  const [depositAmount, setDepositAmount] = useState<number>(0);
  const [depositAmountTaxIncluded, setDepositAmountTaxIncluded] =
    useState<number>(0);
  const [receivableAmount, setReceivableAmount] = useState<number>(0);
  const [receivableAmountTaxIncluded, setReceivableAmountTaxIncluded] =
    useState<number>(0);
  const [materialCost, setMaterialCost] = useState<number>(0);
  const [outsourcingCost, setOutsourcingCost] = useState<number>(0);
  const [executionCost, setExecutionCost] = useState<number>(0);
  const [costDifference, setCostDifference] = useState<number>(0);
  const [grossProfitDifference, setGrossProfitDifference] = useState<number>(0);
  const [grossProfitRateDifference, setGrossProfitRateDifference] =
    useState<number>(0);
  const [execustionGrossProfit, setExecustionGrossProfit] = useState<number>(0);
  const [execustionGrossProfitRate, setExecustionGrossProfitRate] =
    useState<number>(0);
  const [dailyGrossProfit, setDailyGrossProfit] = useState<number>(0);
  const [constructDays, setConstructDays] = useState<number>(0);

  // 実行材料費
  const [workingBudgetsMaterialCost, setWorkingBudgetsMaterialCost] =
    useState<number>(0);
  // 実行外注費
  const [workingBudgetsOutsourcingCost, setWorkingBudgetsOutsourcingCost] =
    useState<number>(0);
  // 追加原価
  const [additionalCost, setAdditionalCost] = useState<number>(0);

  const [companyName, setCompanyName] = useState('');
  const [companyCode, setCompanyCode] = useState('');
  const [companyPostalCode1, setCompanyPostalCode1] = useState('');
  const [companyPostalCode2, setCompanyPostalCode2] = useState('');
  const [companyAddress, setCompanyAddress] = useState('');
  const [companyPhoneNumber, setCompanyPhoneNumber] = useState('');
  const [companyFaxNumber, setCompanyFaxNumber] = useState('');
  const [latitude, setLatitude] = useState(35.69575);
  const [longitude, setLongitude] = useState(139.77521);
  const [isMarkerChecked, setIsMarkerChecked] = useState(false);
  const [possibleTime, setPossibleTime] = useState('');
  const [parkSpace, setParkSpace] = useState('');
  const [smokingRule, setSmokingRule] = useState('');
  const [importantOthers, setImportantOthers] = useState('');

  const [janitorName, setJanitorName] = useState('');
  const [janitorPhoneNumber, setJanitorPhoneNumber] = useState('');
  const [janitorFaxNumber, setJanitorFaxNumber] = useState('');
  const [janitorWorkHours, setJanitorWorkHours] = useState<string>('');
  const [janitorOthers, setJanitorOthers] = useState('');

  const [deleteItemList, setDeleteItemList] = useState<any>([]);
  const [deleteItemList2, setDeleteItemList2] = useState<any>([]);

  const [smallExpenseItems, setSmallExpenseItems] = useState<any>([]);

  const [showLinearProgress, setShowLinearProgress] = useState(false);

  // 選択タブ番号(1:工事情報、2:書類情報、3:現場情報、4:追加情報)
  const [selectTab, setSelectTab] = useState<number>(1);

  // パスパラメータから工事idを取得する
  const params: any = useParams();

  const [defaultValues, setDefaultValues] = useState<TInfoBox[]>();

  useEffect(() => {
    getData();
    window.scrollTo(0, 0);
  }, []);

  const getData = () => {
    getExtInfoBoxes(params.id, EXT_INFO_SCREEN_TYPE.CONSTRUCT).then(
      (data: any) => {
        if (data.data === 'Not logged in!') {
          setOpen(true);
          setErrorMessage(data.data);
        } else {
          if (typeof data.data === 'string') {
            setOpen(true);
            setErrorMessage(data.data);
          } else {
            setDefaultValues(data.data);
          }
        }
      }
    );
  };

  const addNewSmallExpenseItems = () => {
    let copySmallExpenseItems = [...smallExpenseItems];
    let i = copySmallExpenseItems.length;
    let newItem: any = {
      id: '',
      name: '',
      price: ''
    };
    if (i) {
      newItem.id = copySmallExpenseItems[i - 1].id + 1;
    } else {
      newItem.id = 1;
    }
    copySmallExpenseItems.push(newItem);
    setSmallExpenseItems([...copySmallExpenseItems]);
  };

  const deleteSmallExpenseItems = (i: number) => {
    let copySmallExpenseItems: any[] = _.cloneDeep(smallExpenseItems);
    let newSmallExpenseItems = copySmallExpenseItems.filter(
      item => item.id !== i
    );
    setSmallExpenseItems(newSmallExpenseItems);
    let newExecutionCost: any = '';
    if (newSmallExpenseItems.length > 0) {
      let items = [...newSmallExpenseItems];
      let priceArray: number[] = [];
      items.map(item => priceArray.push(item.price) || 0);
      let totalPrice: number = priceArray.reduce((a, b) => a + b);
      setSmallExpenses(totalPrice);
      newExecutionCost =
        outsourcingCost + materialCost + totalPrice + additionalCost;
      setExecutionCost(newExecutionCost);
    } else {
      setSmallExpenses(0);
      newExecutionCost = outsourcingCost + materialCost + additionalCost;
      setExecutionCost(newExecutionCost);
    }
    let newCostDifference =
      newExecutionCost - (isNaN(plannedCost) ? 0 : plannedCost);
    setCostDifference(newCostDifference);
  };

  const additionSmallExpenseItemsPrice = () => {
    let items = [...smallExpenseItems];
    let priceArray: number[] = [];
    items.map(item => priceArray.push(item.price));
    let totalPrice: number = priceArray.reduce((a, b) => a + b);
    if (totalPrice) {
      setSmallExpenses(totalPrice);
    } else {
      setSmallExpenses(0);
    }
    let newExecutionCost =
      outsourcingCost + materialCost + totalPrice + additionalCost;
    setExecutionCost(newExecutionCost);
    let newCostDifference =
      newExecutionCost - (isNaN(plannedCost) ? 0 : plannedCost);
    setCostDifference(newCostDifference);
  };

  const getListOfConstructionTypes = useCallback(() => {
    getConstructionTypes().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setTypesData(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  const getListOfScales = useCallback(() => {
    getScaleList().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setScaleData(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  const getListOfAssigneeRoles = useCallback(() => {
    getAssigneeRoles().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setAssigneeRoleData(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  const getListOfPrefectures = useCallback(() => {
    getPrefectureList().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setPrefectureData(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  const getListOfUsers = useCallback(() => {
    getEmployeeMasterList('', 1).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setUserData(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  const getTheDetailsOfConstrctions = () => {
    getConstructionDetails(params.id).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setCode(data.data.code);
            setConstructType(data.data.construct_type);
            setRenewStatus(data.data.renew_status);
            if (data.data.building_scale) {
              setBuildingScale(data.data.building_scale);
            }

            setTopConstructionName(data.data.name);
            setName(data.data.name);
            if (data.data.site_prefecture) {
              setSitePrefecture(data.data.site_prefecture);
            }
            setSiteAddress1(data.data.site_address1);
            setSiteAddress2(data.data.site_address2);
            setSiteAddress3(data.data.site_address3);
            setRemarks(data.data.remarks);

            setContractorPrefecture(data.data.contractor_prefecture);
            setContractorAddress1(data.data.contractor_address1);
            setContractorAddress2(data.data.contractor_address2);
            setContractorAddress3(data.data.contractor_address3);

            setContractorName(data.data.contractor_name);
            setContractorTel(data.data.contractor_tel);
            setProgress(data.data.progress_status);
            if (data.data.planned_cost) {
              setPlannedCost(data.data.planned_cost);
            }
            if (data.data.planned_days) {
              setPlannedDays(data.data.planned_days);
            }
            if (data.data.planned_gross_profit) {
              setPlannedGrossProfit(data.data.planned_gross_profit);
            }
            if (data.data.planned_gross_profit_rate) {
              setPlannedGrossProfitRate(data.data.planned_gross_profit_rate);
            }
            setContractDate(data.data.contract_date);
            if (data.data.contract_date !== '') {
              setSelectedContractDate(new Date(data.data.contract_date));
            }
            setStartDate(data.data.start_date);
            if (data.data.start_date !== '') {
              setSelectedStartDate(new Date(data.data.start_date));
            }
            setEndDate(data.data.end_date);
            if (data.data.end_date !== '') {
              setSelectedEndDate(new Date(data.data.end_date));
            }
            setBillingDate(data.data.billing_date);
            if (data.data.billing_date !== '') {
              setSelectedBillingDate(new Date(data.data.billing_date));
            }
            setPaymentDate(data.data.payment_date);
            if (data.data.payment_date !== '') {
              setSelectedPaymentDate(new Date(data.data.payment_date));
            }
            setFailureDate(data.data.failure_date);
            if (data.data.failure_date !== '') {
              setSelectedFailureDate(new Date(data.data.failure_date));
            }
            setInspectionDate(data.data.inspection_date);
            if (data.data.inspection_date !== '') {
              setSelectedInspectionDate(new Date(data.data.inspection_date));
            }
            setContractTaxRate(data.data.contract_tax_rate);
            setExpectedContractDate(data.data.expected_contract_date);
            if (data.data.expected_contract_date !== '') {
              setSelectedExpectedContractDate(
                new Date(data.data.expected_contract_date)
              );
            }
            setExpectedStartDate(data.data.expected_start_date);
            if (data.data.expected_start_date !== '') {
              setSelectedExpectedStartDate(
                new Date(data.data.expected_start_date)
              );
            }
            setExpectedEndDate(data.data.expected_end_date);
            if (data.data.expected_end_date !== '') {
              setSelectedExpectedEndDate(new Date(data.data.expected_end_date));
            }
            setExpectedPaymentDate(data.data.expected_payment_date);
            if (data.data.expected_payment_date) {
              setSelectedExpectedPaymentDate(
                new Date(data.data.expected_payment_date)
              );
            }
            if (data.data.small_expenses && data.data.small_expenses !== '') {
              setSmallExpenses(data.data.small_expenses);
            }
            if (data.data.small_expense_items.length > 0) {
              let items = [...data.data.small_expense_items];
              // 小口経費明細ができる前のデータをGetすると、nameにnullが入って、保存時にエラーになる為。
              if (items[0].name === null) {
                items[0].name = '';
              }
              setSmallExpenseItems(items);
              let priceArray: number[] = [];
              items.map(item => priceArray.push(item.price));
              let totalPrice: number = priceArray.reduce((a, b) => a + b);
              setSmallExpenses(totalPrice);
            }
            setTopClientName(data.data.client_name);
            setClientName(data.data.client_name);
            setClientTel(data.data.client_tel);
            setClientPrefecture(data.data.client_prefecture);
            setClientAddress1(data.data.client_address1);
            setClientAddress2(data.data.client_address2);
            setClientAddress3(data.data.client_address3);

            setOrderAmount(data.data.order_amount);
            setOrderAmountTaxIncluded(data.data.order_amount_tax_included);
            setDepositAmount(data.data.deposit_amount);
            setDepositAmountTaxIncluded(data.data.deposit_amount_tax_included);
            setReceivableAmount(data.data.receivable_amount);
            setReceivableAmountTaxIncluded(
              data.data.receivable_amount_tax_included
            );
            setMaterialCost(data.data.material_cost);
            setOutsourcingCost(data.data.outsourcing_cost);

            // 実行材料費
            setWorkingBudgetsMaterialCost(
              data.data.working_budgets_material_cost
            );
            // 実行外注費
            setWorkingBudgetsOutsourcingCost(
              data.data.working_budgets_outsourcing_cost
            );
            // 追加原価
            setAdditionalCost(data.data.additional_cost);

            setExecutionCost(data.data.execution_cost);
            setCostDifference(data.data.cost_difference);
            setGrossProfitDifference(data.data.gross_profit_difference);
            setGrossProfitRateDifference(
              data.data.gross_profit_rate_difference
            );
            setExecustionGrossProfit(data.data.execustion_gross_profit);
            setExecustionGrossProfitRate(
              data.data.execustion_gross_profit_rate
            );
            setDailyGrossProfit(data.data.daily_gross_profit);
            setCompanyName(data.data.company_name);
            setCompanyCode(data.data.company_code);
            setCompanyPostalCode1(data.data.company_postal_code.slice(0, 3));
            setCompanyPostalCode2(data.data.company_postal_code.slice(-4));
            setCompanyAddress(data.data.company_address);
            setCompanyPhoneNumber(data.data.company_phone_number);
            setCompanyFaxNumber(data.data.company_fax_number);
            setLatitude(data.data.latitude);
            setLongitude(data.data.longitude);
            setIsMarkerChecked(data.data.is_marker_checked);
            setPossibleTime(data.data.possible_time);
            setParkSpace(data.data.park_space);
            setSmokingRule(data.data.smoking_rule);
            setImportantOthers(data.data.important_others);
            setJanitorName(data.data.janitor_name);
            setJanitorPhoneNumber(data.data.janitor_phone_number);
            setJanitorFaxNumber(data.data.janitor_fax_number);
            setJanitorWorkHours(data.data.janitor_work_hours);
            setJanitorOthers(data.data.janitor_others);
            setConstructDays(data.data.construct_days);
            let iIds: any = [];
            let iIds2: any = [];
            let iRowCount: any = rowCount;
            let iRowCount2: any = rowCount2;
            let iAssigneeUser: any = [];
            let iAssigneeRole: any = [];
            let iContributionList: any = [];
            let iIndividualSalesList: any = [];
            let iAssigneeOutsidePartner: any = [];
            let iAssigneeOutsidePartnerRole: any = [];
            let iStaffDataList: StaffData[] = [];
            // 社外パートナーの登録があるか判定
            let hasOutsidePartner = data.data.assignee_list.some(
              (k: any) => k.assignee_role === ASSIGNEE_ROLE['OUTSIDE_PARTNER']
            );
            if (!hasOutsidePartner) {
              iRowCount2.push(1);
              setRowCount2(iRowCount2);
            }
            data.data.assignee_list.map((k: any, index: number) => {
              if (k.assignee_role !== ASSIGNEE_ROLE['OUTSIDE_PARTNER']) {
                // 担当者
                if (index === 0) {
                  setRowCount(iRowCount);
                } else {
                  iRowCount.push(1);
                  setRowCount(iRowCount);
                }
                iIds.push(k.id);
                iAssigneeUser.push(k.assignee_user);
                setAssigneeUser(iAssigneeUser);
                iAssigneeRole.push(k.assignee_role);
                setAssigneeRole(iAssigneeRole);
                // 無効化されている担当者のリスト（担当者プルダウン用）
                if (k.assignee_user_name !== '') {
                  const existsFlag = iStaffDataList.some(
                    (staff: StaffData) => staff.id === k.assignee_user
                  );

                  if (!existsFlag) {
                    iStaffDataList.push({
                      name: k.assignee_user_name,
                      id: k.assignee_user
                    });
                  }
                }

                iContributionList.push(parseFloat(k.contribution));
                setContributionList(iContributionList);

                iIndividualSalesList.push(
                  (parseFloat(k.contribution) * data.data.order_amount) / 100
                );
                setIndividualSalesList(iIndividualSalesList);
              } else {
                // 社外パートナー
                iRowCount2.push(1);
                setRowCount2(iRowCount2);
                iIds2.push(k.id);
                iAssigneeOutsidePartner.push(k.assignee_user);
                setAssigneeOutsidePartner(iAssigneeOutsidePartner);
                iAssigneeOutsidePartnerRole.push(k.assignee_role);
                setAssigneeOutsidePartnerRole(iAssigneeOutsidePartnerRole);
              }
              setStaffDataList(iStaffDataList);
              return <></>;
            });
            setItemIds(iIds);
            setItemIds2(iIds2);
            setLoading(false);
          }
        }
      }
    });
  };

  const handleConstructionNameChange = (text: string) => {
    const rawText = text;
    let cleanText = '';
    let charCount = 0; // 全体の文字数カウント
    let lineCharCount = 0; // 各行の文字数カウント
    let lineCount = 1; // 行数カウント

    for (let i = 0; i < rawText.length; i++) {
      // 文字が改行コードかチェック
      if (rawText[i] === '\n' || rawText[i] === '\r') {
        // Windowsの改行コード（\r\n）を考慮
        if (rawText[i] === '\r' && rawText[i + 1] === '\n') {
          i++;
        }
        lineCount++;
        lineCharCount = 0; // 各行の文字数カウントをリセット

        if (lineCount > 2) {
          alert('2行まで入力可能です');
          break;
        }
        cleanText += rawText[i];
      } else {
        charCount++;
        lineCharCount++;

        // 改行がある場合のみ各行の30文字制限を適用
        if (lineCount > 1 && lineCharCount > 30) {
          alert('1行あたり30文字まで入力可能です');
          break;
        }

        // 全体の60文字制限
        if (charCount > 60) {
          alert('60文字まで入力可能です');
          break;
        }
        cleanText += rawText[i];
      }
    }

    setName(cleanText);
  };

  useEffect(() => {
    getListOfConstructionTypes();
    getListOfScales();
    getListOfPrefectures();
    getListOfUsers();
    getListOfAssigneeRoles();
    getTheDetailsOfConstrctions();
    // 無限ループになるためgetTheDetailsOfConstructionsを除外
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    getListOfConstructionTypes,
    getListOfScales,
    getListOfPrefectures,
    getListOfUsers,
    getListOfAssigneeRoles
  ]);

  useEffect(() => {
    setReceivableAmount(
      orderAmount +
        calcTax(orderAmount, contractTaxRate / 100, taxRule) -
        depositAmount
    );
  }, [orderAmount, contractTaxRate, depositAmount, receivableAmount]);

  useEffect(() => {
    setReceivableAmountTaxIncluded(
      orderAmountTaxIncluded - depositAmountTaxIncluded
    );
  }, [
    orderAmountTaxIncluded,
    contractTaxRate,
    depositAmountTaxIncluded,
    receivableAmountTaxIncluded
  ]);

  const updateConstructionDetails = () => {
    setShowLinearProgress(true);
    let small_expense_item: any = [];
    for (let n = 0; n < smallExpenseItems.length; n++) {
      if (
        smallExpenseItems[n].price !== '' &&
        smallExpenseItems[n].name.length <= 30
      ) {
        small_expense_item[n] = {
          name: smallExpenseItems[n].name,
          price: smallExpenseItems[n].price,
          id: smallExpenseItems[n].id
        };
      } else if (smallExpenseItems[n].name.length > 30) {
        setErrorMessage('経費項目は30文字以内で入力してください。');
        setOpen(true);
        return;
      } else if (smallExpenseItems[n].price === '') {
        setErrorMessage('金額を入力してください。');
        setOpen(true);
        return;
      }
    }
    setSmallExpenseItems(small_expense_item);

    let contriSum = 0;
    for (let i = 0; i < contributionList.length; i++) {
      contriSum += contributionList[i];
    }
    if (code.trim() === '') {
      setErrorMessage('工事番号を入力してください。');
      setOpen(true);
    } else if (code.length > 10) {
      setErrorMessage('工事番号は10文字以内で記入してください。');
      setOpen(true);
    } else if (constructType === 0 || !constructType) {
      setErrorMessage('案件種別を選択してください。');
      setOpen(true);
    } else if (renewStatus === 0) {
      setErrorMessage('「新規」または「リピート」を選択してください。');
      setOpen(true);
    } else if (name.trim() === '') {
      setErrorMessage('工事件名を入力してください。');
      setOpen(true);
    } else if (
      userMenu != 'Storage' &&
      userMenu !== 'SiteManage' &&
      progress === 0
    ) {
      setErrorMessage('進行状況を入力してください。');
      setOpen(true);
    } else if (
      contractorTel.trim() !== '' &&
      (isPhoneNumber.test(contractorTel.trim()) ||
        contractorTel.trim().length > 20)
    ) {
      setErrorMessage('無効な連絡先TELです。');
      setOpen(true);
    } else if (
      userMenu != 'Storage' &&
      userMenu !== 'SiteManage' &&
      assigneeUser.length === 0
    ) {
      setErrorMessage('担当者名を入力してください。');
      setOpen(true);
    } else if (userMenu != 'Storage' && assigneeRole.length === 0) {
      setErrorMessage('担当役割を入力してください。');
      setOpen(true);
    } else if (userMenu != 'Storage' && contributionList.length === 0) {
      setErrorMessage('貢献度を入力してください。');
      setOpen(true);
    } else if (
      new Set(assigneeOutsidePartner).size !== assigneeOutsidePartner.length
    ) {
      setErrorMessage('社外パートナーが重複しています。');
      setOpen(true);
    } else if (userMenu != 'Storage' && contriSum !== 100) {
      setErrorMessage('貢献度の合計は100％でなければなりません。');
      setOpen(true);
    } else if (companyName.length > 30) {
      setErrorMessage('会社名は30文字以内で入力してください。');
      setOpen(true);
    } else if (
      companyPhoneNumber.trim() !== '' &&
      (isPhoneNumber.test(companyPhoneNumber.trim()) ||
        companyPhoneNumber.trim().length > 20)
    ) {
      setErrorMessage('無効な電話番号です。');
      setOpen(true);
    } else if (
      companyPostalCode1 !== '' &&
      companyPostalCode2 !== '' &&
      (companyPostalCode1.length !== 3 || companyPostalCode2.length !== 4)
    ) {
      setErrorMessage('郵便番号の形式が間違っています。');
      setOpen(true);
    } else {
      let l1 = assigneeUser.length;
      let l2 = assigneeRole.length;
      let l3 = contributionList.length;
      let l4 = individualSalesList.length;
      let l5 = assigneeOutsidePartner.length;
      let l6 = assigneeOutsidePartnerRole.length;

      let flag = false;
      if (l1 === l2 && l2 === l3 && l3 === l4) {
        flag = true;
      }
      // データ保存用の配列
      // 担当者
      let items: any = [];
      if (flag === true) {
        for (let i = 0; i < assigneeUser.length; i++) {
          let lenName = assigneeUser.length;
          let lenId = itemIds.length;
          let newArr1 = Array(lenName - lenId).fill(0);
          let concatArray1 = itemIds;
          let concatArray2 = concatArray1.concat(newArr1);
          setItemIds(concatArray2);

          items[i] = {
            id: concatArray2[i],
            assignee_user: assigneeUser[i],
            assignee_role: assigneeRole[i],
            contribution: contributionList[i],
            individual_sales: individualSalesList[i]
          };
          if (deleteItemList) {
            items.push(...deleteItemList);
          }
        }

        let arr: any = [];
        for (let n = 0; n < items.length; n++) {
          if (
            items[n].assignee_user ||
            items[n].assignee_role ||
            items[n].contribution ||
            items[n].individual_sales
          ) {
            arr.push(items[n]);
          }
        }

        // 社外パートナー
        let flag2 = false;
        if (l5 === l6) {
          flag2 = true;
        }
        let items2: any = [];
        if (flag2 === true) {
          for (let i = 0; i < assigneeOutsidePartner.length; i++) {
            let lenName2 = assigneeOutsidePartner.length;
            let lenId2 = itemIds2.length;
            let newArr2 = Array(lenName2 - lenId2).fill(0);
            let concatArray3 = itemIds2;
            let concatArray4 = concatArray3.concat(newArr2);
            setItemIds2(concatArray4);

            items2[i] = {
              id: concatArray4[i],
              assignee_user: assigneeOutsidePartner[i],
              assignee_role: assigneeOutsidePartnerRole[i],
              contribution: 0,
              individual_sales: 0
            };
            if (deleteItemList2) {
              items2.push(...deleteItemList2);
            }
          }
          if (l5 === 0 && deleteItemList2) {
            items2.push(...deleteItemList2);
          }

          let arr2: any = [];
          for (let n = 0; n < items2.length; n++) {
            if (items2[n].assignee_user || items2[n].assignee_role) {
              arr2.push(items2[n]);
            }
          }
          updateFunction(arr, arr2);
        } else {
          setErrorMessage('社外パートナー情報を設定してください。');
          setOpen(true);
        }
      } else {
        setErrorMessage('担当者を設定してください。');
        setOpen(true);
      }
    }
    setShowLinearProgress(false);
  };

  const updateFunction = (newAssigneeArr: any, newOutsidePartnerArr: any) => {
    setIsSaved(true);
    const constructId = history.location.state.constructId
      ? history.location.state.constructId
      : params.id;

    updateConstruction(
      constructId,
      code.trim(),
      constructType,
      renewStatus,
      buildingScale,
      name.trim(),
      sitePrefecture,
      siteAddress1.trim(),
      siteAddress2.trim(),
      siteAddress3.trim(),
      remarks,
      contractorPrefecture,
      contractorAddress1.trim(),
      contractorAddress2.trim(),
      contractorAddress3.trim(),
      contractorName.trim(),
      contractorTel.trim(),
      progress,
      plannedCost,
      plannedDays,
      plannedGrossProfit,
      selectedContractDate !== null ? contractDate : '',
      selectedStartDate !== null ? startDate : '',
      selectedEndDate !== null ? endDate : '',
      selectedBillingDate !== null ? billingDate : '',
      selectedPaymentDate !== null ? paymentDate : '',
      selectedFailureDate !== null ? failureDate : '',
      selectedInspectionDate !== null ? inspectionDate : '',
      contractTaxRate,
      selectedExpectedContractDate !== null ? expectedContractDate : '',
      selectedExpectedStartDate !== null ? expectedStartDate : '',
      selectedExpectedEndDate !== null ? expectedEndDate : '',
      selectedExpectedPaymentDate !== null ? expectedPaymentDate : '',
      smallExpenses,
      newAssigneeArr,
      newOutsidePartnerArr,
      companyName.trim(),
      String(companyCode.trim()),
      String(companyPostalCode1.trim()) + String(companyPostalCode2.trim()),
      companyAddress.trim(),
      String(companyPhoneNumber.trim()),
      String(companyFaxNumber.trim()),
      latitude,
      longitude,
      isMarkerChecked,
      possibleTime.trim(),
      parkSpace.trim(),
      smokingRule.trim(),
      importantOthers.trim(),
      janitorName.trim(),
      janitorPhoneNumber.trim(),
      janitorFaxNumber.trim(),
      janitorWorkHours.trim(),
      janitorOthers.trim(),
      smallExpenseItems
    ).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setErrorMessage(data.message);
            setOpenSuccess(true);
            // 更新後の無効化された担当者一覧（担当者プルダウン用）
            let newStaffData: StaffData[] = [];
            for (let i = 0; i < staffDataList.length; i++) {
              let newStaffFlag = false;
              for (let j = 0; j < newAssigneeArr.length; j++) {
                // 削除された担当者は無視
                if (newStaffFlag && newAssigneeArr[j].id !== 0) {
                  break;
                }
                // 新規追加された担当者
                if (newAssigneeArr[j] === 0) {
                  newStaffFlag = true;
                }
                if (newAssigneeArr[j].assignee_user === staffDataList[i].id) {
                  newStaffData.push(staffDataList[i]);
                  break;
                }
              }
            }
            setStaffDataList(newStaffData);
            getListOfUsers();
          }
        }
      }
    });
  };

  // 担当者1行削除
  const deleteFunction = (j: number) => {
    if (rowCount.length === 1) {
      setErrorMessage('担当者情報は、1行以上必要です。');
      setOpen(true);
    } else {
      let newAssigneeRole: any = [...assigneeRole];
      let newContributionList: any = [...contributionList];
      let newAssigneeUser: any = [...assigneeUser];
      let newRowCount: any = [...rowCount];
      let newIndividualSalesList: any = [...individualSalesList];
      const deleteItem = {
        id: itemIds[j],
        assignee_user: assigneeUser[j],
        assignee_role: assigneeRole[j],
        contribution: contributionList[j],
        individual_sales: individualSalesList[j],
        delete: true
      };
      setDeleteItemList([...deleteItemList, deleteItem]);
      newAssigneeUser.splice(j, 1);
      newAssigneeRole.splice(j, 1);
      newContributionList.splice(j, 1);
      newIndividualSalesList.splice(j, 1);
      newRowCount.splice(j, 1);
      if (newAssigneeUser.length !== newRowCount.length) {
        newAssigneeUser.push(0);
      }
      if (newAssigneeRole.length !== newRowCount.length) {
        newAssigneeRole.push(0);
      }
      if (newContributionList.length !== newRowCount.length) {
        newContributionList.push(0);
      }
      if (newIndividualSalesList.length !== newRowCount.length) {
        newIndividualSalesList.push(0);
      }
      let newItemIds: any = [...itemIds];
      newItemIds.splice(j, 1);
      setItemIds(newItemIds);
      setRowCount(newRowCount);
      setAssigneeUser(newAssigneeUser);
      setContributionList(newContributionList);
      setIndividualSalesList(newIndividualSalesList);
      setAssigneeRole(newAssigneeRole);
      setIsSaved(false);
    }
  };

  // 社外パートナー1行削除
  const deleteFunction2 = (j: number) => {
    let newAssigneeOutsidePartnerRole: any = [...assigneeOutsidePartnerRole];
    let newAssigneeOutsidePartner: any = [...assigneeOutsidePartner];
    let newRowCount2: any = [...rowCount2];
    const deleteItem2 = {
      id: itemIds2[j],
      assignee_user: assigneeOutsidePartner[j],
      assignee_role: assigneeOutsidePartnerRole[j],
      contribution: 0,
      individual_sales: 0,
      delete: true
    };
    setDeleteItemList2([...deleteItemList2, deleteItem2]);
    newAssigneeOutsidePartner.splice(j, 1);
    newAssigneeOutsidePartnerRole.splice(j, 1);
    newRowCount2.splice(j, 1);
    if (newAssigneeOutsidePartner.length !== newRowCount2.length) {
      newAssigneeOutsidePartner.push(0);
    }
    if (newAssigneeOutsidePartnerRole.length !== newRowCount2.length) {
      newAssigneeOutsidePartnerRole.push(0);
    }
    let newItemIds2: any = [...itemIds2];
    newItemIds2.splice(j, 1);
    setItemIds2(newItemIds2);
    setRowCount2(newRowCount2);
    setAssigneeOutsidePartner(newAssigneeOutsidePartner);
    setAssigneeOutsidePartnerRole(newAssigneeOutsidePartnerRole);
    setIsSaved(false);
  };

  const handleCompanyAdressChange = (text: string) => {
    const rawText = text;
    let cleanText = '';
    let charCount = 0; // 全体の文字数カウント
    let lineCharCount = 0; // 各行の文字数カウント
    let lineCount = 1; // 行数カウント

    for (let i = 0; i < rawText.length; i++) {
      // 文字が改行コードかチェック
      if (rawText[i] === '\n' || rawText[i] === '\r') {
        // Windowsの改行コード（\r\n）を考慮
        if (rawText[i] === '\r' && rawText[i + 1] === '\n') {
          i++;
        }
        lineCount++;
        lineCharCount = 0; // 各行の文字数カウントをリセット

        if (lineCount > 3) {
          alert('3行まで入力可能です');
          break;
        }
        cleanText += rawText[i];
      } else {
        charCount++;
        lineCharCount++;

        // 改行がある場合に各行の20文字制限を適用
        if (lineCount > 1 && lineCharCount > 20) {
          alert('1行あたり20文字まで入力可能です');
          break;
        }

        // 全体の60文字制限
        if (charCount > 60) {
          alert('全体で60文字まで入力可能です');
          break;
        }
        cleanText += rawText[i];
      }
    }

    setCompanyAddress(cleanText);
  };

  const handleCompanyAddressFetch = async () => {
    try {
      const result = await fetchAddressFromPostalCode(
        `${companyPostalCode1}${companyPostalCode2}`
      );

      if (result.success) {
        const addressData = result.data;

        // address1からaddress3を結合してaddressにセット
        const fullAddress = `${addressData.prefecture || ''}${
          addressData.city || ''
        }${addressData.suburb || ''}`.trim();
        setCompanyAddress(fullAddress);

        setErrorMessage('');
      } else {
        setErrorMessage(result.message || '住所の取得に失敗しました');
        setOpen(true);
      }
    } catch (error) {
      setErrorMessage(
        'システムエラーが発生しました。住所は手動で入力してください。'
      );
      setOpen(true);
    }
  };

  const patternState: TTopicPathState = {};
  patternState['/constructions'] = history.location.state;

  if (loggedIn === 'Not logged in!') {
    return <Redirect to='/' />;
  }

  return (
    <>
      <AppBarComponent
        patternName='constructions_edit'
        patternState={patternState}
      />
      {loading ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponent isFormGroup={true} />
        </>
      ) : (
        <>
          <div
            style={{
              overflow: 'hidden',
              backgroundColor: '#F5F5F5',
              minHeight: window.innerHeight
            }}
          >
            <div style={{ margin: 15 }}>
              <Snackbar
                open={open}
                autoHideDuration={4000}
                onClose={handleClose}
              >
                <Alert onClose={handleClose} severity='error'>
                  {errorMessage}
                </Alert>
              </Snackbar>

              <Snackbar
                open={openSuccess}
                autoHideDuration={4000}
                onClose={handleCloseSuccess}
              >
                <Alert onClose={handleCloseSuccess} severity='success'>
                  {errorMessage}
                </Alert>
              </Snackbar>
              <div className='table-top-container-customer'>
                <div style={{ fontWeight: 'bold' }}>
                  <Button
                    style={{
                      minWidth: 90,
                      marginRight: 15,
                      color: '#758283',
                      backgroundColor: '#F5F5F5',
                      marginBottom: !matches2 ? 10 : 0
                    }}
                    variant='contained'
                    color='secondary'
                    onClick={() => {
                      // アラートメールからアクセスした場合は、工事一覧へ戻る
                      if (history.location.state) {
                        if (history.location.state.params) {
                          history.push(
                            '/constructions',
                            history.location.state
                          );
                        } else if (history.location.state?.currentPage) {
                          history.push(
                            '/constructions',
                            history.location.state
                          );
                        } else {
                          history.goBack();
                        }
                      } else {
                        history.push('/constructions');
                      }
                    }}
                    startIcon={<ArrowBackIcon />}
                  >
                    戻る
                  </Button>
                </div>
              </div>
            </div>

            {showLinearProgress && (
              <LinearProgress className={classes.progress} />
            )}

            <div style={{ backgroundColor: '#FFFFFF' }}>
              <div className={classes.topContainer}>
                <div
                  style={{
                    backgroundColor: '#FFFFFF',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    marginLeft: 15,
                    marginTop: 24
                  }}
                >
                  <div style={{ fontSize: 18 }}>{topConstructionName}</div>
                  <div style={{ fontSize: 14, fontWeight: 'lighter' }}>
                    {topClientName}
                  </div>
                </div>
                <div>
                  {userMenu != 'BM' && (
                    <>
                      <ListButton
                        variant='contained'
                        style={{ marginRight: 12, marginTop: 24 }}
                        onClick={() => {
                          history.push(`/files`, {
                            state: { id: params.id, name: name }
                          });
                        }}
                      >
                        資料一覧
                      </ListButton>
                      <ListButton
                        variant='contained'
                        style={{ marginRight: 12, marginTop: 24 }}
                        onClick={() => {
                          history.push(`/pictures`, {
                            state: { id: params.id, name: name }
                          });
                        }}
                      >
                        写真一覧
                      </ListButton>
                    </>
                  )}
                  {/* NOTE: メニュー出し分けリリースまでの暫定対応 */}
                  {userSiteManagePlan != 99 && (
                    <ListButton
                      variant='contained'
                      style={{ marginRight: 15, marginTop: 24 }}
                      onClick={() => {
                        history.push(`/processes`, {
                          constructId: params.id,
                          name: topConstructionName
                        });
                      }}
                    >
                      工程表
                    </ListButton>
                  )}
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: matches2 ? 'row' : 'column'
                }}
                className={classes.topList}
              >
                <div
                  // 空アイテム
                  className='empty-list'
                  style={{ width: 15 }}
                ></div>
                <div
                  onClick={() => setSelectTab(1)}
                  className='border2'
                  style={{
                    backgroundColor: selectTab == 1 ? '#F5F5F5' : '#ffffff',
                    borderTopColor: selectTab == 1 ? '#0099CB' : '#cccccc',
                    borderBottom: selectTab == 1 ? 'none' : 'solid 1px #cccccc',
                    width: 200
                  }}
                >
                  <div
                    className={classes.topColumn}
                    style={{ color: selectTab == 1 ? '#0099CB' : '#000000' }}
                  >
                    工事情報
                  </div>
                </div>
                {/* 業務管理を使用しないテナントには書類情報タブを表示しない */}
                {userMenu !== 'Storage' &&
                  userMenu !== 'SiteManage' &&
                  authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                    <div
                      onClick={() => {
                        if (isSaved == true) {
                          history.push(
                            `/constructions_document/${params.id}/edit`,
                            {
                              constructId: params.id
                            }
                          );
                        } else {
                          setErrorMessage('保存してください。');
                          setOpen(true);
                        }
                      }}
                      className='border2'
                    >
                      <div className={classes.topColumn}>書類情報</div>
                    </div>
                  )}
                {/* ストレージのみのテナントには現場情報タブを表示しない */}
                {userMenu !== 'Storage' && (
                  <div
                    onClick={() => {
                      if (isSaved == true) {
                        history.push(
                          `/constructions_location/${params.id}/edit`,
                          {
                            constructId: params.id
                          }
                        );
                      } else {
                        setErrorMessage('保存してください。');
                        setOpen(true);
                      }
                    }}
                    className='border2'
                  >
                    <div className={classes.topColumn}>現場情報</div>
                  </div>
                )}
                {authInfo?.role != ROLE['OUTSIDE_PARTNER'] &&
                  defaultValues &&
                  defaultValues.length > 0 && (
                    <div
                      onClick={() => setSelectTab(4)}
                      className='border2'
                      style={{
                        backgroundColor: selectTab == 4 ? '#F5F5F5' : '#ffffff',
                        borderTopColor: selectTab == 4 ? '#0099CB' : '#cccccc',
                        borderBottom:
                          selectTab == 4 ? 'none' : 'solid 1px #cccccc',
                        width: 200
                      }}
                    >
                      <div
                        className={classes.topColumn}
                        style={{
                          color: selectTab == 4 ? '#0099CB' : '#000000'
                        }}
                      >
                        追加情報
                      </div>
                    </div>
                  )}
                <div
                  // 空アイテム
                  className='empty-list'
                  style={{ flexGrow: 1 }}
                ></div>
              </div>
            </div>

            {/** 工事情報の場合 */}
            {selectTab == 1 && (
              <>
                <div style={{ margin: 15 }}>
                  <div>
                    <Grid
                      container
                      style={{
                        backgroundColor: '#FFFFFF',
                        paddingBottom: 15,
                        marginBottom: 15
                      }}
                    >
                      <Grid item xs={matches2 ? 4 : 12}>
                        <div
                          style={{
                            backgroundColor: '#FFFFFF',
                            display: 'flex',
                            alignItems: 'center',
                            paddingBottom: '15px'
                          }}
                        >
                          <div
                            style={{
                              fontWeight: 'bold',
                              padding: 15,
                              paddingBottom: 0,
                              fontSize: 24,
                              marginRight: 80
                            }}
                          >
                            工事案件
                          </div>
                        </div>
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              工事番号<span>*</span>
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainer}>
                              <input
                                value={code}
                                onChange={e => {
                                  setCode(e.target.value);
                                  setIsSaved(false);
                                }}
                                className={classes.input}
                                disabled={
                                  authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                }
                              />
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div
                            className={classes.textMainContainer}
                            style={{ height: 100 }}
                          >
                            <div className={classes.textContainer}>
                              工事件名<span>*</span>
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainer}>
                              <textarea
                                value={name}
                                placeholder='60文字以内、2行以内'
                                onChange={e => {
                                  handleConstructionNameChange(e.target.value);
                                  setIsSaved(false);
                                }}
                                className={classes.input}
                                disabled={
                                  authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                }
                                style={{ height: 100, maxHeight: 100 }}
                              />
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              案件種別<span>*</span>
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainerSelectBox}>
                              <select
                                value={constructType}
                                onChange={e => {
                                  setConstructType(parseInt(e.target.value));
                                  setIsSaved(false);
                                }}
                                className={classes.selectBoxStyle}
                                style={{
                                  backgroundColor:
                                    authInfo?.role == 4 ? 'lightgray' : ''
                                }}
                                name='cars'
                                id='cars'
                                form='carform'
                                disabled={
                                  authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                }
                              >
                                <option value={0}>選択してください</option>
                                {typesData.map((i: any) => (
                                  <option value={i.id}>{i.name}</option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              新規・リピート<span>*</span>
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center'
                              }}
                            >
                              <div
                                onClick={() => {
                                  if (
                                    authInfo?.role != ROLE['OUTSIDE_PARTNER']
                                  ) {
                                    setRenewStatus(1);
                                    setIsSaved(false);
                                  }
                                }}
                                style={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  alignItems: 'center',
                                  padding: 8
                                }}
                              >
                                <div
                                  className='checkbox'
                                  style={{
                                    borderColor:
                                      authInfo?.role == 4 ? 'lightgray' : ''
                                  }}
                                >
                                  {renewStatus === 1 && (
                                    <div
                                      style={{
                                        backgroundColor:
                                          authInfo?.role == 4 ? 'lightgray' : ''
                                      }}
                                      className='dot'
                                    />
                                  )}
                                </div>
                                <div style={{ fontSize: 16, marginLeft: 5 }}>
                                  新規
                                </div>
                              </div>
                              <div
                                onClick={() => {
                                  if (
                                    authInfo?.role != ROLE['OUTSIDE_PARTNER']
                                  ) {
                                    setRenewStatus(2);
                                    setIsSaved(false);
                                  }
                                }}
                                style={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  alignItems: 'center',
                                  padding: 8
                                }}
                              >
                                <div
                                  className='checkbox'
                                  style={{
                                    borderColor:
                                      authInfo?.role == 4 ? 'lightgray' : ''
                                  }}
                                >
                                  {renewStatus === 2 && (
                                    <div
                                      style={{
                                        backgroundColor:
                                          authInfo?.role == 4 ? 'lightgray' : ''
                                      }}
                                      className='dot'
                                    />
                                  )}
                                </div>
                                <div style={{ fontSize: 16, marginLeft: 5 }}>
                                  リピート
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />

                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              物件規模
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainerSelectBox}>
                              <select
                                onChange={e => {
                                  setBuildingScale(parseInt(e.target.value));
                                  setIsSaved(false);
                                }}
                                value={buildingScale}
                                className={classes.selectBoxStyle}
                                style={{
                                  backgroundColor:
                                    authInfo?.role == 4 ? 'lightgray' : ''
                                }}
                                name='cars'
                                id='cars'
                                form='carform'
                                disabled={
                                  authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                }
                              >
                                <option value={0}>選択してください</option>
                                {scaleData.map((i: any) => (
                                  <option value={i.id}>{i.name}</option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer2}>
                            <div className={classes.textContainer}>備考欄</div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainer}>
                              <textarea
                                value={remarks}
                                onChange={e => {
                                  setRemarks(e.target.value);
                                  setIsSaved(false);
                                }}
                                className={classes.inputnew}
                                disabled={
                                  authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                }
                              />
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                      </Grid>

                      <Grid item xs={matches2 ? 4 : 12}>
                        <div
                          className='table-top-container-customer'
                          style={{ backgroundColor: '#FFFFFF' }}
                        >
                          <div className='question-position'>
                            <div
                              style={{
                                fontWeight: 'bold',
                                padding: 15,
                                paddingBottom: 0,
                                paddingRight: 0,
                                fontSize: 24
                              }}
                            >
                              契約者
                            </div>
                            <CustomTooltip
                              title={tooltipContents.contractor}
                              placement='right'
                            >
                              <HelpIcon
                                color='action'
                                style={{ marginTop: 16, marginLeft: 8 }}
                              />
                            </CustomTooltip>
                          </div>
                        </div>
                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              契約者名
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainer}>
                              <input
                                value={contractorName}
                                onChange={e => {
                                  setContractorName(e.target.value);
                                  setIsSaved(false);
                                }}
                                className={classes.input}
                                disabled={
                                  authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />

                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              契約者住所 都道府県
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainerSelectBox}>
                              <select
                                value={contractorPrefecture}
                                onChange={e => {
                                  setContractorPrefecture(
                                    parseInt(e.target.value)
                                  );
                                  setIsSaved(false);
                                }}
                                className={classes.selectBoxStyle}
                                style={{
                                  backgroundColor:
                                    authInfo?.role == 4 ? 'lightgray' : ''
                                }}
                                name='cars'
                                id='cars'
                                form='carform'
                                disabled={
                                  authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                }
                              >
                                <option value={0}>選択してください</option>
                                {prefectureData.map((i: any) => (
                                  <option value={i.id}>{i.name}</option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              契約者住所 市区町村
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainer}>
                              <input
                                value={contractorAddress1}
                                onChange={e => {
                                  setContractorAddress1(e.target.value);
                                  setIsSaved(false);
                                }}
                                className={classes.input}
                                disabled={
                                  authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                }
                              />
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              契約者住所 町名・番地
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainer}>
                              <input
                                onChange={e => {
                                  setContractorAddress2(e.target.value);
                                  setIsSaved(false);
                                }}
                                value={contractorAddress2}
                                className={classes.input}
                                disabled={
                                  authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                }
                              />
                            </div>
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />

                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              契約者住所 建物名
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainer}>
                              <input
                                value={contractorAddress3}
                                onChange={e => {
                                  setContractorAddress3(e.target.value);
                                  setIsSaved(false);
                                }}
                                className={classes.input}
                                disabled={
                                  authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />

                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              契約者TEL
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainer}>
                              <input
                                value={contractorTel}
                                onChange={e => {
                                  setContractorTel(e.target.value);
                                  setIsSaved(false);
                                }}
                                className={classes.input}
                                disabled={
                                  authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                      </Grid>

                      <Grid item xs={matches2 ? 4 : 12}>
                        <div
                          className='table-top-container-customer'
                          style={{ backgroundColor: '#FFFFFF' }}
                        >
                          <div
                            style={{
                              fontWeight: 'bold',
                              padding: 15,
                              paddingBottom: 0,
                              fontSize: 24
                            }}
                          >
                            顧客
                          </div>
                        </div>

                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>顧客名</div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainerSelectBox}>
                              {clientName}
                            </div>
                          </div>
                        </div>
                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />

                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>顧客TEL</div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainerSelectBox}>
                              {clientTel}
                            </div>
                          </div>
                        </div>
                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />

                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              顧客住所 都道府県
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainerSelectBox}>
                              {clientPrefecture}
                            </div>
                          </div>
                        </div>
                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />

                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              顧客住所 市区町村
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainerSelectBox}>
                              {clientAddress1}
                            </div>
                          </div>
                        </div>
                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />

                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              顧客住所 町名・番地
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainerSelectBox}>
                              {clientAddress2}
                            </div>
                          </div>
                        </div>
                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />

                        <div className={classes.subContainer}>
                          <div className={classes.textMainContainer}>
                            <div className={classes.textContainer}>
                              顧客住所 建物名
                            </div>
                          </div>
                          <div className={classes.inputMainContainer}>
                            <div className={classes.inputContainerSelectBox}>
                              {clientAddress3}
                            </div>
                          </div>
                        </div>
                        <Divider
                          style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                        />
                      </Grid>
                    </Grid>

                    {userMenu != 'Storage' &&
                      authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                        <>
                          <div
                            className='table-top-container-customer'
                            style={{ backgroundColor: '#FFFFFF' }}
                          >
                            <div
                              style={{
                                fontWeight: 'bold',
                                padding: 15,
                                paddingBottom: 0,
                                fontSize: 24
                              }}
                            >
                              担当者情報
                            </div>
                          </div>

                          <div style={{ backgroundColor: '#FFFFFF' }}>
                            <div
                              style={{
                                backgroundColor: '#FFFFFF',
                                marginLeft: 15,
                                marginRight: 15,
                                marginBottom: 0
                              }}
                            >
                              <TableContainer component={Paper}>
                                <Table aria-label='customized table'>
                                  <TableHead>
                                    <TableRow>
                                      <StyledTableCell
                                        className={classes.table}
                                        align='left'
                                      >
                                        担当者名<span>*</span>
                                      </StyledTableCell>
                                      <StyledTableCell
                                        className={classes.table}
                                        align='left'
                                      >
                                        担当役割<span>*</span>
                                      </StyledTableCell>
                                      <StyledTableCell
                                        className={classes.table}
                                        align='left'
                                      >
                                        貢献度（％）<span>*</span>
                                      </StyledTableCell>
                                      <StyledTableCell
                                        className={classes.table}
                                        align='left'
                                      >
                                        個人別売上
                                      </StyledTableCell>
                                      <StyledTableCell
                                        className={classes.table}
                                        align='left'
                                        style={{ minWidth: 110 }}
                                      ></StyledTableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {rowCount.map((i: any, j: number) => (
                                      <StyledTableRow>
                                        <StyledTableCell
                                          className={classes.table1}
                                          style={{ minWidth: 140 }}
                                          align='left'
                                        >
                                          <select
                                            value={assigneeUser[j]}
                                            onChange={text => {
                                              let newNameArr: any = [
                                                ...assigneeUser
                                              ];
                                              newNameArr[j] = parseInt(
                                                text.target.value
                                              );
                                              setAssigneeUser(newNameArr);
                                              setIsSaved(false);
                                            }}
                                            className={classes.inputBottom}
                                            style={{ height: 35 }}
                                          >
                                            <option value={0}>
                                              選択してください
                                            </option>
                                            {/* // role_id=4(社外パートナー)の場合はスキップ */}
                                            {getStaffSelectOptions(
                                              userData.filter(
                                                (i: any) => i.role_id !== 4
                                              ),
                                              staffDataList
                                            )}
                                          </select>
                                        </StyledTableCell>

                                        <StyledTableCell
                                          className={classes.table1}
                                          style={{ minWidth: 140 }}
                                          align='left'
                                        >
                                          <select
                                            value={assigneeRole[j]}
                                            onChange={text => {
                                              let newNameArr: any = [
                                                ...assigneeRole
                                              ];
                                              newNameArr[j] = parseInt(
                                                text.target.value
                                              );
                                              setAssigneeRole(newNameArr);

                                              setIsSaved(false);
                                            }}
                                            className={classes.inputBottom}
                                            style={{ height: 35 }}
                                          >
                                            <option value={0}>
                                              選択してください
                                            </option>
                                            {assigneeRoleData.map((i: any) => {
                                              if (i.id === 5) {
                                                return null; // id=5の場合はスキップする
                                              }
                                              return (
                                                <option value={i.id}>
                                                  {i.name}
                                                </option>
                                              );
                                            })}
                                          </select>
                                        </StyledTableCell>

                                        <StyledTableCell
                                          className={classes.table1}
                                          style={{ minWidth: 140 }}
                                          align='left'
                                        >
                                          <Grid
                                            container
                                            direction='row'
                                            alignItems='center'
                                          >
                                            <Grid>
                                              <input
                                                type='number'
                                                value={
                                                  contributionList[j] === 0
                                                    ? ''
                                                    : contributionList[j]
                                                }
                                                onChange={text => {
                                                  let newNameArr: any = [
                                                    ...contributionList
                                                  ];
                                                  newNameArr[j] = parseFloat(
                                                    text.target.value
                                                  );
                                                  setContributionList(
                                                    newNameArr
                                                  );
                                                  setIsSaved(false);

                                                  let newIndividualSales: any =
                                                    [...individualSalesList];
                                                  newIndividualSales[j] =
                                                    (parseFloat(
                                                      text.target.value
                                                    ) *
                                                      orderAmount) /
                                                    100;
                                                  setIndividualSalesList(
                                                    newIndividualSales
                                                  );
                                                  setIsSaved(false);
                                                }}
                                                className={
                                                  classes.inputContributionListBottom
                                                }
                                                onWheel={(e: any) =>
                                                  e.target.blur()
                                                }
                                              />
                                            </Grid>
                                            <Grid style={{ marginLeft: 20 }}>
                                              %
                                            </Grid>
                                          </Grid>
                                        </StyledTableCell>

                                        <StyledTableCell
                                          className={classes.table1}
                                          style={{ minWidth: 140 }}
                                          align='right'
                                        >
                                          <div style={{ fontSize: 16 }}>
                                            {parsePrice(individualSalesList[j])}
                                          </div>
                                        </StyledTableCell>
                                        <StyledTableCell
                                          style={{ minWidth: 110 }}
                                          align='right'
                                        >
                                          <Button
                                            style={{
                                              backgroundColor: buttonColor
                                            }}
                                            variant='contained'
                                            color='primary'
                                            startIcon={<DeleteIcon />}
                                            onClick={() => {
                                              deleteFunction(j);
                                            }}
                                          >
                                            削除
                                          </Button>
                                        </StyledTableCell>
                                      </StyledTableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>

                            <div
                              style={{
                                marginTop: 15,
                                display: 'flex',
                                justifyContent: 'space-between',
                                marginRight: 15
                              }}
                            >
                              <div />
                              <CustomTooltip
                                title={
                                  tooltipContents.constructionsCreateManager
                                }
                                placement='left'
                              >
                                <Button
                                  style={{ backgroundColor: buttonColor }}
                                  variant='contained'
                                  color='secondary'
                                  startIcon={<AddToPhotosIcon />}
                                  onClick={() => {
                                    let len = rowCount.length - 1;
                                    let contributionSum = 0;
                                    for (
                                      let i = 0;
                                      i < contributionList.length;
                                      i++
                                    ) {
                                      contributionSum += contributionList[i];
                                    }
                                    if (
                                      (rowCount.length === 0 ||
                                        (assigneeUser[len] &&
                                          assigneeRole[len] &&
                                          contributionList[len])) &&
                                      contributionSum <= 100
                                    ) {
                                      setRowCount([...rowCount, 1]);
                                      setIsSaved(false);
                                    } else {
                                      if (contributionSum > 100) {
                                        setErrorMessage(
                                          '貢献度100％を超えることはできません。'
                                        );
                                        setOpen(true);
                                      } else {
                                        setOpen(true);
                                        setErrorMessage(
                                          'すべての項目の入力が必須です。'
                                        );
                                      }
                                    }
                                  }}
                                >
                                  追加
                                </Button>
                              </CustomTooltip>
                            </div>
                            <div
                              style={{
                                height: 15,
                                backgroundColor: '#F5F5F5',
                                marginTop: 15
                              }}
                            />
                          </div>
                        </>
                      )}

                    {userMenu != 'Storage' &&
                      authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                        <>
                          <div
                            className='table-top-container-customer'
                            style={{ backgroundColor: '#FFFFFF' }}
                          >
                            <div
                              style={{
                                fontWeight: 'bold',
                                padding: 15,
                                paddingBottom: 0,
                                fontSize: 24
                              }}
                            >
                              社外パートナー情報
                            </div>
                          </div>

                          <div style={{ backgroundColor: '#FFFFFF' }}>
                            <div
                              style={{
                                backgroundColor: '#FFFFFF',
                                marginLeft: 15,
                                marginRight: 15,
                                marginBottom: 0
                              }}
                            >
                              <TableContainer component={Paper}>
                                <Table aria-label='customized table'>
                                  <TableHead>
                                    <TableRow>
                                      <StyledTableCell
                                        className={classes.table}
                                        align='left'
                                      >
                                        氏名
                                      </StyledTableCell>
                                      <StyledTableCell
                                        className={classes.table}
                                        align='left'
                                        style={{ minWidth: 110 }}
                                      >
                                        権限
                                      </StyledTableCell>

                                      {/* <StyledTableCell
                                    className={classes.table}
                                    align="left"
                                  >
                                  </StyledTableCell>
                                  <StyledTableCell
                                    className={classes.table}
                                    align="left"
                                  >
                                  </StyledTableCell> */}

                                      <StyledTableCell
                                        className={classes.table}
                                        align='left'
                                        style={{ minWidth: 110 }}
                                      ></StyledTableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {rowCount2.map((i: any, j: number) => (
                                      <StyledTableRow>
                                        <StyledTableCell
                                          className={classes.table1}
                                          style={{
                                            minWidth: 140,
                                            width: '20%'
                                          }}
                                          align='left'
                                        >
                                          <select
                                            value={assigneeOutsidePartner[j]}
                                            onChange={text => {
                                              let newNameArr2: any = [
                                                ...assigneeOutsidePartner
                                              ];
                                              newNameArr2[j] = parseInt(
                                                text.target.value
                                              );
                                              setAssigneeOutsidePartner(
                                                newNameArr2
                                              );
                                              setIsSaved(false);
                                            }}
                                            className={classes.inputBottom}
                                            style={{ height: 35 }}
                                          >
                                            <option value={0}>
                                              選択してください
                                            </option>
                                            {userData.map((i: any) =>
                                              // role_id=4(社外パートナー)のみ表示
                                              i.role_id === 4 ? (
                                                <option value={i.id}>
                                                  {i.name}
                                                </option>
                                              ) : null
                                            )}
                                          </select>
                                        </StyledTableCell>

                                        <StyledTableCell
                                          className={classes.table1}
                                          style={{
                                            minWidth: 140,
                                            width: '20%'
                                          }}
                                          align='left'
                                        >
                                          <select
                                            value={
                                              assigneeOutsidePartnerRole[j]
                                            }
                                            onChange={text => {
                                              let newNameArr2: any = [
                                                ...assigneeOutsidePartnerRole
                                              ];
                                              newNameArr2[j] = parseInt(
                                                text.target.value
                                              );
                                              setAssigneeOutsidePartnerRole(
                                                newNameArr2
                                              );
                                              setIsSaved(false);
                                            }}
                                            className={classes.inputBottom}
                                            style={{
                                              height: 35,
                                              minWidth: 110,
                                              width: '80%'
                                            }}
                                          >
                                            <option value={0}>
                                              選択してください
                                            </option>
                                            <option value={5}>
                                              社外パートナー
                                            </option>
                                          </select>
                                        </StyledTableCell>
                                        {rowCount2.length === 1 && ( // 1行のみの場合
                                          <StyledTableCell
                                            style={{
                                              minWidth: 110,
                                              width: '10%'
                                            }}
                                            align='right'
                                          ></StyledTableCell>
                                        )}
                                        {rowCount2.length != 1 && ( // ２行以上の場合
                                          <StyledTableCell
                                            style={{
                                              minWidth: 110,
                                              width: '10%'
                                            }}
                                            align='right'
                                          >
                                            <Button
                                              style={{
                                                backgroundColor: buttonColor
                                              }}
                                              variant='contained'
                                              color='primary'
                                              startIcon={<DeleteIcon />}
                                              onClick={() => {
                                                deleteFunction2(j);
                                              }}
                                            >
                                              削除
                                            </Button>
                                          </StyledTableCell>
                                        )}
                                      </StyledTableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                            <div
                              style={{
                                marginTop: 15,
                                display: 'flex',
                                justifyContent: 'space-between',
                                marginRight: 15
                              }}
                            >
                              <div />

                              <CustomTooltip
                                title={
                                  tooltipContents.constructionsCreateOutsidePartner
                                }
                                placement='left'
                              >
                                <Button
                                  style={{ backgroundColor: buttonColor }}
                                  variant='contained'
                                  color='secondary'
                                  startIcon={<AddToPhotosIcon />}
                                  onClick={() => {
                                    let len2 = rowCount2.length - 1;
                                    if (
                                      assigneeOutsidePartner[len2] &&
                                      assigneeOutsidePartnerRole[len2]
                                    ) {
                                      setRowCount2([...rowCount2, 1]);
                                      setIsSaved(false);
                                    } else {
                                      setOpen(true);
                                      setErrorMessage(
                                        'すべての項目の入力が必須です。'
                                      );
                                    }
                                  }}
                                >
                                  追加
                                </Button>
                              </CustomTooltip>
                            </div>
                            <div
                              style={{
                                height: 15,
                                backgroundColor: '#F5F5F5',
                                marginTop: 15
                              }}
                            />
                          </div>
                        </>
                      )}

                    {userMenu != 'Storage' &&
                      userMenu !== 'SiteManage' &&
                      authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                        <>
                          <div
                            className='table-top-container-customer'
                            style={{ backgroundColor: '#FFFFFF' }}
                          >
                            <div
                              style={{
                                fontWeight: 'bold',
                                padding: 15,
                                paddingBottom: 0,
                                fontSize: 24
                              }}
                            >
                              管理情報
                            </div>
                          </div>
                          <Grid
                            style={{ backgroundColor: '#FFFFFF' }}
                            container
                          >
                            <Grid item xs={matches2 ? 4 : 12}>
                              <div className={classes.subContainer}>
                                <div className={classes.textMainContainer}>
                                  <div className={classes.textContainer}>
                                    受注金額（税別）
                                  </div>
                                </div>
                                <div className={classes.inputMainContainer}>
                                  <div className={classes.textContainerPrice}>
                                    {parsePrice(orderAmount)}
                                  </div>
                                </div>
                              </div>
                              <Divider
                                style={{
                                  backgroundColor: '#CCCCCC',
                                  marginLeft: 15
                                }}
                              />
                            </Grid>
                          </Grid>
                          <Grid
                            style={{
                              backgroundColor: '#FFFFFF',
                              paddingTop: 15
                            }}
                            container
                          >
                            <Grid item xs={matches2 ? 4 : 12}>
                              <div className={classes.subContainer}>
                                <div className={classes.textMainContainer}>
                                  <div className={classes.textContainer}>
                                    受注金額（税込）
                                  </div>
                                </div>
                                <div className={classes.inputMainContainer}>
                                  <div className={classes.textContainerPrice}>
                                    {parsePrice(orderAmountTaxIncluded)}
                                  </div>
                                </div>
                              </div>
                              <Divider
                                style={{
                                  backgroundColor: '#CCCCCC',
                                  marginLeft: 15
                                }}
                              />

                              <div className={classes.subContainer}>
                                <div className={classes.textMainContainer}>
                                  <div className={classes.textContainer}>
                                    入金額（税込）
                                  </div>
                                </div>
                                <div className={classes.inputMainContainer}>
                                  <div className={classes.textContainerPrice}>
                                    {parsePrice(depositAmountTaxIncluded)}
                                  </div>
                                </div>
                              </div>
                              <Divider
                                style={{
                                  backgroundColor: '#CCCCCC',
                                  marginLeft: 15
                                }}
                              />

                              <div className={classes.subContainer}>
                                <div className={classes.textMainContainer}>
                                  <div className={classes.textContainer}>
                                    未収金額（税込）
                                  </div>
                                </div>
                                <div className={classes.inputMainContainer}>
                                  <div className={classes.textContainerPrice}>
                                    {parsePrice(receivableAmountTaxIncluded)}
                                  </div>
                                </div>
                              </div>
                              <Divider
                                style={{
                                  backgroundColor: '#CCCCCC',
                                  marginLeft: 15
                                }}
                              />
                            </Grid>

                            <Grid item xs={matches2 ? 4 : 12}>
                              <div className={classes.subContainer}>
                                <div className={classes.textMainContainer}>
                                  <div className={classes.textContainer}>
                                    計画原価（円）
                                  </div>
                                </div>
                                <div className={classes.inputMainContainer}>
                                  <div className={classes.inputContainer}>
                                    <NumberInput
                                      value={
                                        plannedCost !== 0 ? plannedCost : ''
                                      }
                                      onChange={(
                                        e: React.ChangeEvent<HTMLInputElement>
                                      ) => {
                                        setPlannedCost(
                                          parseInt(e.target.value)
                                        );
                                        let newPlannedCost = parseInt(
                                          e.target.value
                                        );
                                        let newCostDifference =
                                          executionCost -
                                          (newPlannedCost ? newPlannedCost : 0);
                                        setCostDifference(newCostDifference);
                                        let newPlannedGrossProfit =
                                          orderAmount - newPlannedCost;
                                        setPlannedGrossProfit(
                                          newPlannedGrossProfit
                                        );
                                        let newPlannedGrossProfitRate = 0;
                                        if (orderAmount > 0) {
                                          newPlannedGrossProfitRate =
                                            (newPlannedGrossProfit /
                                              orderAmount) *
                                            100;
                                          setPlannedGrossProfitRate(
                                            Math.round(
                                              newPlannedGrossProfitRate
                                            )
                                          );
                                        }
                                        let newGrossProfitRateDifference =
                                          execustionGrossProfitRate -
                                          newPlannedGrossProfitRate;
                                        setGrossProfitRateDifference(
                                          Math.round(
                                            newGrossProfitRateDifference
                                              ? newGrossProfitRateDifference
                                              : 0
                                          )
                                        );
                                        let newGrossProfitDifference =
                                          execustionGrossProfit -
                                          newPlannedGrossProfit;
                                        setGrossProfitDifference(
                                          newGrossProfitDifference
                                        );
                                        setIsSaved(false);
                                      }}
                                      className={classes.input}
                                      style={{ textAlign: 'right' }}
                                    />
                                  </div>
                                </div>
                              </div>
                              <Divider
                                style={{
                                  backgroundColor: '#CCCCCC',
                                  marginLeft: 15
                                }}
                              />

                              <div className={classes.subContainer}>
                                <div className={classes.textMainContainer}>
                                  <div className={classes.textContainer}>
                                    実行原価
                                  </div>
                                </div>
                                <div className={classes.inputMainContainer}>
                                  <div className={classes.textContainerPrice}>
                                    {parsePrice(executionCost)}
                                  </div>
                                </div>
                              </div>
                              <Divider
                                style={{
                                  backgroundColor: '#CCCCCC',
                                  marginLeft: 15
                                }}
                              />

                              <div className={classes.subContainer}>
                                <div className={classes.textMainContainer}>
                                  <div className={classes.textContainer}>
                                    原価予実差異
                                  </div>
                                </div>
                                <div className={classes.inputMainContainer}>
                                  <div className={classes.textContainerPrice}>
                                    {parsePrice(costDifference)}
                                  </div>
                                </div>
                              </div>
                              <Divider
                                style={{
                                  backgroundColor: '#CCCCCC',
                                  marginLeft: 15
                                }}
                              />
                            </Grid>

                            <Grid item xs={matches2 ? 4 : 12}>
                              <div className={classes.subContainer}>
                                <div className={classes.textMainContainer}>
                                  <div className={classes.textContainer}>
                                    計画粗利率
                                  </div>
                                </div>
                                <div className={classes.inputMainContainer}>
                                  <div
                                    className={
                                      classes.inputContainerSelectBoxAlignRight
                                    }
                                  >
                                    {plannedGrossProfitRate
                                      ? plannedGrossProfitRate
                                      : 0}{' '}
                                    %
                                  </div>
                                </div>
                              </div>
                              <Divider
                                style={{
                                  backgroundColor: '#CCCCCC',
                                  marginLeft: 15
                                }}
                              />

                              <div className={classes.subContainer}>
                                <div className={classes.textMainContainer}>
                                  <div className={classes.textContainer}>
                                    実行粗利率
                                  </div>
                                </div>
                                <div className={classes.inputMainContainer}>
                                  <div
                                    className={
                                      classes.inputContainerSelectBoxAlignRight
                                    }
                                  >
                                    {execustionGrossProfitRate} %
                                  </div>
                                </div>
                              </div>
                              <Divider
                                style={{
                                  backgroundColor: '#CCCCCC',
                                  marginLeft: 15
                                }}
                              />

                              <div className={classes.subContainer}>
                                <div className={classes.textMainContainer}>
                                  <div className={classes.textContainer}>
                                    粗利率予実差異
                                  </div>
                                </div>
                                <div className={classes.inputMainContainer}>
                                  <div
                                    className={
                                      classes.inputContainerSelectBoxAlignRight
                                    }
                                  >
                                    {grossProfitRateDifference} %
                                  </div>
                                </div>
                              </div>
                              <Divider
                                style={{
                                  backgroundColor: '#CCCCCC',
                                  marginLeft: 15
                                }}
                              />
                            </Grid>
                          </Grid>

                          <Grid
                            style={{
                              backgroundColor: '#FFFFFF',
                              paddingTop: 15,
                              paddingBottom: 15,
                              marginBottom: 15
                            }}
                            container
                          >
                            <Grid item xs={matches2 ? 4 : 12}>
                              <div className={classes.subContainer}>
                                <div className={classes.textMainContainer}>
                                  <div className={classes.textContainer}>
                                    計画粗利
                                  </div>
                                </div>
                                <div className={classes.inputMainContainer}>
                                  <div className={classes.textContainerPrice}>
                                    {parsePrice(plannedGrossProfit)}
                                  </div>
                                </div>
                              </div>
                              <Divider
                                style={{
                                  backgroundColor: '#CCCCCC',
                                  marginLeft: 15
                                }}
                              />

                              <div className={classes.subContainer}>
                                <div className={classes.textMainContainer}>
                                  <div className={classes.textContainer}>
                                    実行粗利
                                  </div>
                                </div>
                                <div className={classes.inputMainContainer}>
                                  <div className={classes.textContainerPrice}>
                                    {parsePrice(execustionGrossProfit)}
                                  </div>
                                </div>
                              </div>
                              <Divider
                                style={{
                                  backgroundColor: '#CCCCCC',
                                  marginLeft: 15
                                }}
                              />

                              <div className={classes.subContainer}>
                                <div className={classes.textMainContainer}>
                                  <div className={classes.textContainer}>
                                    粗利予実差異
                                  </div>
                                </div>
                                <div className={classes.inputMainContainer}>
                                  <div className={classes.textContainerPrice}>
                                    {parsePrice(grossProfitDifference)}
                                  </div>
                                </div>
                              </div>
                              <Divider
                                style={{
                                  backgroundColor: '#CCCCCC',
                                  marginLeft: 15
                                }}
                              />
                            </Grid>

                            <Grid item xs={matches2 ? 4 : 12}>
                              <div className={classes.subContainer}>
                                <div className={classes.textMainContainer}>
                                  <div className={classes.textContainer}>
                                    小口経費（円）（税別）
                                  </div>
                                </div>
                                <div className={classes.inputMainContainer}>
                                  <div className={classes.textContainerPrice}>
                                    {parsePrice(smallExpenses)}
                                  </div>
                                </div>
                              </div>
                              <Divider
                                style={{
                                  backgroundColor: '#CCCCCC',
                                  marginLeft: 15
                                }}
                              />

                              <div className={classes.subContainer}>
                                <div className={classes.textMainContainer}>
                                  <div className={classes.textContainer}>
                                    材料費（税別）
                                    <br />
                                    （実行予算材料費）
                                  </div>
                                </div>
                                <div className={classes.inputMainContainer}>
                                  <div className={classes.textContainerPrice}>
                                    {parsePrice(materialCost)}
                                    <br />
                                    <span
                                      style={{ color: 'blue' }}
                                    >{`(${parsePrice(
                                      workingBudgetsMaterialCost
                                    )})`}</span>
                                  </div>
                                </div>
                              </div>
                              <Divider
                                style={{
                                  backgroundColor: '#CCCCCC',
                                  marginLeft: 15
                                }}
                              />

                              <div className={classes.subContainer}>
                                <div className={classes.textMainContainer}>
                                  <div className={classes.textContainer}>
                                    外注費（税別）
                                    <br />
                                    （実行予算外注費）
                                  </div>
                                </div>
                                <div className={classes.inputMainContainer}>
                                  <div className={classes.textContainerPrice}>
                                    {parsePrice(outsourcingCost)}
                                    <br />
                                    <span
                                      style={{ color: 'blue' }}
                                    >{`(${parsePrice(
                                      workingBudgetsOutsourcingCost
                                    )})`}</span>
                                  </div>
                                </div>
                              </div>
                              <Divider
                                style={{
                                  backgroundColor: '#CCCCCC',
                                  marginLeft: 15
                                }}
                              />
                            </Grid>

                            <Grid item xs={matches2 ? 4 : 12}>
                              <div className={classes.subContainer}>
                                <div className={classes.textMainContainer}>
                                  <div
                                    className={classes.textContainer}
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center'
                                    }}
                                  >
                                    追加原価
                                    <CustomTooltip
                                      title={tooltipContents.additionalCost}
                                      placement='right'
                                      interactive={true}
                                    >
                                      <HelpIcon
                                        style={{
                                          color: 'white',
                                          marginLeft: 8
                                        }}
                                      />
                                    </CustomTooltip>
                                  </div>
                                </div>
                                <div className={classes.inputMainContainer}>
                                  <div
                                    className={
                                      classes.inputContainerSelectBoxAlignRight
                                    }
                                  >
                                    {parsePrice(additionalCost)}
                                  </div>
                                </div>
                              </div>
                              <Divider
                                style={{
                                  backgroundColor: '#CCCCCC',
                                  marginLeft: 15
                                }}
                              />

                              <div className={classes.subContainer}>
                                <div className={classes.textMainContainer}>
                                  <div className={classes.textContainer}>
                                    予定工事日数
                                  </div>
                                </div>
                                <div className={classes.inputMainContainer}>
                                  <div
                                    className={
                                      classes.inputContainerSelectBoxAlignRight
                                    }
                                  >
                                    {plannedDays > 0 ? `${plannedDays} 日` : ''}
                                  </div>
                                </div>
                              </div>
                              <Divider
                                style={{
                                  backgroundColor: '#CCCCCC',
                                  marginLeft: 15
                                }}
                              />

                              <div className={classes.subContainer}>
                                <div className={classes.textMainContainer}>
                                  <div className={classes.textContainer}>
                                    日割実行粗利
                                  </div>
                                </div>
                                <div className={classes.inputMainContainer}>
                                  <div className={classes.textContainerPrice}>
                                    {parsePrice(dailyGrossProfit)}
                                  </div>
                                </div>
                              </div>
                              <Divider
                                style={{
                                  backgroundColor: '#CCCCCC',
                                  marginLeft: 15
                                }}
                              />
                            </Grid>
                          </Grid>

                          {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                            <>
                              <div
                                className='table-top-container-customer'
                                style={{ backgroundColor: '#FFFFFF' }}
                              >
                                <div
                                  style={{
                                    fontWeight: 'bold',
                                    padding: 15,
                                    paddingBottom: 0,
                                    fontSize: 24
                                  }}
                                >
                                  小口経費明細
                                </div>
                              </div>

                              <div style={{ backgroundColor: '#FFFFFF' }}>
                                <div
                                  style={{
                                    backgroundColor: '#FFFFFF',
                                    marginLeft: 15,
                                    marginRight: 15,
                                    marginBottom: 0
                                  }}
                                >
                                  <TableContainer component={Paper}>
                                    <Table aria-label='customized table'>
                                      <TableHead>
                                        <TableRow>
                                          <StyledTableCell
                                            className={classes.table}
                                            align='left'
                                            style={{
                                              width: '50%',
                                              textAlign: 'center'
                                            }}
                                          >
                                            経費項目
                                          </StyledTableCell>
                                          <StyledTableCell
                                            className={classes.table}
                                            align='left'
                                            style={{
                                              width: '30%',
                                              textAlign: 'center'
                                            }}
                                          >
                                            金額<span>*</span>
                                          </StyledTableCell>
                                          <StyledTableCell
                                            className={classes.table}
                                            align='left'
                                            style={{ width: '20%' }}
                                          ></StyledTableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {smallExpenseItems.map(
                                          (i: any, j: number) => (
                                            <StyledTableRow key={i.id}>
                                              <StyledTableCell
                                                className={classes.table1}
                                                style={{ minWidth: 140 }}
                                                align='left'
                                              >
                                                <div
                                                  className={
                                                    classes.inputContainer
                                                  }
                                                >
                                                  <input
                                                    value={i.name}
                                                    placeholder='30文字以内で入力'
                                                    type='text'
                                                    onChange={text => {
                                                      let newSmallExpenseItems =
                                                        [...smallExpenseItems];
                                                      newSmallExpenseItems[
                                                        j
                                                      ].name =
                                                        text.target.value;
                                                      setSmallExpenseItems(
                                                        newSmallExpenseItems
                                                      );
                                                      setIsSaved(false);
                                                    }}
                                                    className={classes.input}
                                                  />
                                                </div>
                                              </StyledTableCell>

                                              <StyledTableCell
                                                className={classes.table1}
                                                style={{ minWidth: 140 }}
                                                align='left'
                                              >
                                                <NumberInput
                                                  className={classes.input}
                                                  value={i.price}
                                                  onChange={(e: any) => {
                                                    let newSmallExpenseItems = [
                                                      ...smallExpenseItems
                                                    ];
                                                    newSmallExpenseItems[
                                                      j
                                                    ].price = parseInt(
                                                      e.target.value
                                                    );
                                                    if (
                                                      isNaN(
                                                        parseInt(e.target.value)
                                                      )
                                                    ) {
                                                      newSmallExpenseItems[
                                                        j
                                                      ].price = '';
                                                    }
                                                    setSmallExpenseItems(
                                                      newSmallExpenseItems
                                                    );
                                                    setIsSaved(false);
                                                    additionSmallExpenseItemsPrice();
                                                  }}
                                                />
                                              </StyledTableCell>

                                              <StyledTableCell
                                                style={{ minWidth: 110 }}
                                                align='center'
                                              >
                                                <Button
                                                  style={{
                                                    backgroundColor: buttonColor
                                                  }}
                                                  variant='contained'
                                                  color='primary'
                                                  startIcon={<DeleteIcon />}
                                                  onClick={() => {
                                                    deleteSmallExpenseItems(
                                                      i.id
                                                    );
                                                    setIsSaved(false);
                                                  }}
                                                >
                                                  削除
                                                </Button>
                                              </StyledTableCell>
                                            </StyledTableRow>
                                          )
                                        )}
                                      </TableBody>
                                    </Table>
                                  </TableContainer>
                                </div>

                                <div
                                  style={{
                                    marginTop: 15,
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    marginRight: 15
                                  }}
                                >
                                  <div />
                                  <CustomTooltip
                                    title={
                                      tooltipContents.constructionsCreateExpenses
                                    }
                                    placement='left'
                                  >
                                    <Button
                                      style={{ backgroundColor: buttonColor }}
                                      variant='contained'
                                      color='secondary'
                                      startIcon={<AddToPhotosIcon />}
                                      onClick={() => {
                                        addNewSmallExpenseItems();
                                        setIsSaved(false);
                                      }}
                                    >
                                      追加
                                    </Button>
                                  </CustomTooltip>
                                </div>
                                <div
                                  style={{
                                    height: 15,
                                    backgroundColor: '#F5F5F5',
                                    marginTop: 15
                                  }}
                                />
                              </div>
                            </>
                          )}
                          {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                            <>
                              <div
                                className='table-top-container-customer'
                                style={{ backgroundColor: '#FFFFFF' }}
                              >
                                <div className='question-position'>
                                  <div
                                    style={{
                                      fontWeight: 'bold',
                                      padding: 15,
                                      paddingBottom: 0,
                                      paddingRight: 0,
                                      fontSize: 24
                                    }}
                                  >
                                    自社情報
                                  </div>
                                  <CustomTooltip
                                    title={
                                      tooltipContents.constructionsCreateTenant
                                    }
                                    placement='right'
                                  >
                                    <HelpIcon
                                      color='action'
                                      style={{ marginTop: 12, marginLeft: 8 }}
                                    />
                                  </CustomTooltip>
                                </div>
                              </div>
                              <Grid
                                container
                                style={{
                                  backgroundColor: '#FFFFFF',
                                  paddingBottom: 15,
                                  marginBottom: 15
                                }}
                              >
                                <Grid item xs={matches2 ? 6 : 12}>
                                  <Divider
                                    style={{
                                      backgroundColor: '#CCCCCC',
                                      marginLeft: 15
                                    }}
                                  />
                                  <div className={classes.subContainer}>
                                    <div className={classes.textMainContainer}>
                                      <div className={classes.textContainer}>
                                        会社名
                                      </div>
                                    </div>
                                    <div className={classes.inputMainContainer}>
                                      <div
                                        className={classes.inputMainContainer}
                                      >
                                        <div className={classes.inputContainer}>
                                          <input
                                            value={companyName}
                                            maxLength={30}
                                            placeholder='30文字以内'
                                            type='text'
                                            onChange={text => {
                                              setCompanyName(text.target.value);
                                              setIsSaved(false);
                                            }}
                                            className={classes.input}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <Divider
                                    style={{
                                      backgroundColor: '#CCCCCC',
                                      marginLeft: 15
                                    }}
                                  />
                                  <div className={classes.subContainer}>
                                    <div className={classes.textMainContainer}>
                                      <div className={classes.textContainer}>
                                        登録番号
                                      </div>
                                      <CustomTooltip
                                        title={tooltipContents.companyNum}
                                        placement='right'
                                      >
                                        <HelpIcon
                                          style={{
                                            color: 'white',
                                            marginLeft: 8,
                                            marginTop: 1
                                          }}
                                        />
                                      </CustomTooltip>
                                    </div>
                                    <div className={classes.inputMainContainer}>
                                      <div
                                        className={classes.inputMainContainer}
                                      >
                                        <div className={classes.inputContainer}>
                                          <input
                                            value={companyCode}
                                            maxLength={30}
                                            type='text'
                                            onChange={text => {
                                              setCompanyCode(text.target.value);
                                              setIsSaved(false);
                                            }}
                                            className={classes.input}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <Divider
                                    style={{
                                      backgroundColor: '#CCCCCC',
                                      marginLeft: 15
                                    }}
                                  />
                                  <div className={classes.subContainer}>
                                    <div className={classes.textMainContainer}>
                                      <div className={classes.textContainer}>
                                        郵便番号
                                      </div>
                                    </div>
                                    <div className={classes.inputMainContainer}>
                                      <div
                                        className={classes.inputContainer}
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center'
                                        }} // 一行に揃えるためのスタイル追加
                                      >
                                        <div
                                          style={{
                                            display: 'flex',
                                            alignItems: 'center'
                                          }}
                                        >
                                          <input
                                            value={companyPostalCode1}
                                            type='text'
                                            onChange={text => {
                                              setCompanyPostalCode1(
                                                text.target.value
                                              );
                                              setIsSaved(false);
                                            }}
                                            className={classes.inputPostalCode}
                                            style={{
                                              width: '30%',
                                              maxWidth: 60
                                            }}
                                          />
                                          <span style={{ margin: 5 }}> - </span>
                                          <input
                                            value={companyPostalCode2}
                                            type='text'
                                            maxLength={4}
                                            onChange={text => {
                                              setCompanyPostalCode2(
                                                text.target.value
                                              );
                                              setIsSaved(false);
                                            }}
                                            className={classes.inputPostalCode}
                                            style={{ width: 50, maxWidth: 80 }}
                                          />
                                        </div>
                                        <div>
                                          <Button
                                            style={{
                                              backgroundColor: buttonColor,
                                              marginLeft: 6,
                                              padding: '5px 10px',
                                              width: 'auto',
                                              minWidth: '80px'
                                            }}
                                            variant='contained'
                                            color='secondary'
                                            onClick={handleCompanyAddressFetch}
                                          >
                                            住所反映
                                          </Button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <Divider
                                    style={{
                                      backgroundColor: '#CCCCCC',
                                      marginLeft: 15
                                    }}
                                  />
                                  <div
                                    className={classes.subContainer}
                                    style={{ marginBottom: 15 }}
                                  >
                                    <div className={classes.textMainContainer1}>
                                      <div className={classes.textContainer1}>
                                        所在地
                                      </div>
                                    </div>
                                    <div
                                      className={classes.inputMainContainer1}
                                    >
                                      <div className={classes.inputContainer}>
                                        <textarea
                                          value={companyAddress}
                                          placeholder='60文字以内、3行以内'
                                          onChange={e => {
                                            handleCompanyAdressChange(
                                              e.target.value
                                            );
                                            setIsSaved(false);
                                          }}
                                          className={classes.input1}
                                          style={{
                                            width: '100%',
                                            maxHeight: 100
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </Grid>

                                <Grid
                                  item
                                  xs={matches2 ? 6 : 12}
                                  style={{ paddingRight: matches2 ? 15 : 0 }}
                                >
                                  <Divider
                                    style={{
                                      backgroundColor: '#CCCCCC',
                                      marginLeft: 15
                                    }}
                                  />
                                  <div className={classes.subContainer}>
                                    <div className={classes.textMainContainer}>
                                      <div className={classes.textContainer}>
                                        電話番号
                                      </div>
                                    </div>
                                    <div className={classes.inputMainContainer}>
                                      <div
                                        className={classes.inputMainContainer}
                                      >
                                        <div className={classes.inputContainer}>
                                          <input
                                            value={companyPhoneNumber}
                                            type='text'
                                            maxLength={13}
                                            onChange={text => {
                                              setCompanyPhoneNumber(
                                                text.target.value
                                              );
                                              setIsSaved(false);
                                            }}
                                            className={classes.input}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <Divider
                                    style={{
                                      backgroundColor: '#CCCCCC',
                                      marginLeft: 15
                                    }}
                                  />
                                  <div className={classes.subContainer}>
                                    <div className={classes.textMainContainer}>
                                      <div className={classes.textContainer}>
                                        Fax番号
                                      </div>
                                    </div>
                                    <div className={classes.inputMainContainer}>
                                      <div
                                        className={classes.inputMainContainer}
                                      >
                                        <div className={classes.inputContainer}>
                                          <input
                                            value={companyFaxNumber}
                                            type='text'
                                            maxLength={13}
                                            onChange={text => {
                                              setCompanyFaxNumber(
                                                text.target.value
                                              );
                                              setIsSaved(false);
                                            }}
                                            className={classes.input}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </Grid>
                              </Grid>
                            </>
                          )}
                        </>
                      )}
                  </div>
                </div>
                {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                  <>
                    <div style={{ height: 80 }} />
                    <div
                      className='save-btn-container'
                      style={{
                        backgroundColor: '#FFFFFF',
                        position: 'fixed',
                        bottom: 0,
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-around'
                      }}
                    >
                      <div />
                      <div>
                        <Button
                          onClick={updateConstructionDetails}
                          style={{
                            paddingLeft: 50,
                            paddingRight: 50,
                            margin: 20,
                            backgroundColor: buttonColor
                          }}
                          variant='contained'
                          color='primary'
                          disabled={showLinearProgress}
                        >
                          保存
                        </Button>
                      </div>
                      <div />
                    </div>
                  </>
                )}
              </>
            )}

            {/** 追加情報の場合 */}
            {selectTab == 4 && defaultValues && defaultValues.length > 0 && (
              <>
                <ExtInfoBoxes
                  defaultValues={defaultValues}
                  targetId={params.id}
                  ext_info_screen_type={EXT_INFO_SCREEN_TYPE.CONSTRUCT}
                  setOpen={setOpen}
                  setOpenSuccess={setOpenSuccess}
                  setErrorMessage={setErrorMessage}
                  getData={getData}
                />
                <div style={{ height: 80 }} />
              </>
            )}
          </div>
        </>
      )}
    </>
  );
};
